var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinMobileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 100,
    viewBox: "0 0 105 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000008579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.2169 9H74.9026C77.7834 9 80.1191 11.3352 80.1191 14.2165V78.5925V93.2794C80.1191 96.1864 77.7559 98.496 74.9026 98.496H36.2169C33.3391 98.496 31.0004 96.1637 31.0004 93.2794V28.9035V14.2165C31.0005 11.3097 33.3635 9 36.2169 9Z",
    fill: "#FFD580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.5287 16.1094H77.5898V91.3859H33.5287V16.1094Z",
    fill: "#FFF6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.481 60.3573C39.986 60.0129 36.6213 56.0898 36.9657 51.5948C37.3101 47.0998 41.2333 43.7351 45.7283 44.0795C50.2233 44.4239 53.588 48.347 53.2436 52.842C52.8991 57.337 48.976 60.7018 44.481 60.3573Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.9652 47.5029L40.8398 56.2344L42.4149 57.5197L49.5403 48.7883L47.9652 47.5029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.1826 49.734L48.9141 56.8594L50.1994 55.2843L41.468 48.1589L40.1826 49.734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.5287 86.9336H77.5898V91.3864H33.5287V86.9336Z",
    fill: "#FFE5B2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M59.8225 58.3716C56.5278 55.077 56.5278 49.7353 59.8224 46.4407C63.117 43.1461 68.4586 43.1461 71.7533 46.4408C75.0479 49.7354 75.048 55.077 71.7533 58.3717C68.4587 61.6663 63.1171 61.6662 59.8225 58.3716Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M71.6592 48.4058L65.1924 58.3589L63.994 56.5138L70.0011 47.3222L71.6592 48.4058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.5474 52.0482L65.1923 58.3676L65.6915 55.8997L62.1655 50.9058L60.5474 52.0482Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M74.1613 58.1863C73.3613 56.9544 71.7116 56.6067 70.476 57.4091L70.3149 57.5137C68.746 58.5326 68.2976 60.6258 69.3123 62.1883L71.6723 66.085L76.8701 74.6713C76.9782 74.97 80.7427 80.8422 80.7427 80.8422C79.9192 80.6602 78.9924 80.442 78.1379 80.2123C76.1432 79.6765 73.4513 80.1907 71.9323 80.9487C71.1319 81.3475 70.6289 81.8186 70.4347 82.3487C70.3734 82.5196 70.3217 82.6996 70.2823 82.8831C70.0178 84.074 70.2186 85.5895 71.2793 86.107C71.7403 86.3345 72.2787 86.3346 72.8487 86.3315C73.6056 86.3298 74.7461 86.12 75.9785 86.5399C78.0453 87.2476 82.7561 88.7706 85.4821 89.4462C85.9515 89.4364 87.1172 89.681 87.5677 89.6421C89.003 89.6295 90.2274 89.6992 90.729 89.842C91.1204 89.9527 92.8901 89.768 92.8901 89.768C94.4053 89.7485 96.7731 89.1125 99.0322 87.6454C101.287 86.1812 103.423 84.9855 104.075 82.6747L104.156 82.6221L104.131 82.4958C104.758 80.0895 104.45 77.5191 103.05 75.3647C102.704 74.8319 101.428 72.867 101.189 72.4975L96.3614 65.0644C96.0334 64.5594 94.8232 62.9398 93.0658 63.3586C92.2222 63.561 91.6333 64.0743 91.235 64.6708L91.1093 64.7602L91.0711 64.7888C90.2193 64.0204 89.2097 63.8229 88.189 64.2593C86.9574 64.7875 86.404 65.6156 86.1595 66.249C85.0625 65.5636 83.8094 65.649 82.632 66.562C81.7492 67.2469 81.3515 68.155 81.239 69.085L77.1229 62.7467L74.1613 58.1863Z",
    fill: "#CDCDCD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinMobileCheck);
export default __webpack_public_path__ + "static/media/linkedinMobileCheck.0c50a0a579200f533a624e36a6d147e9.svg";
export { ForwardRef as ReactComponent };